{
  "version": 1,
  "asset_id": "b559d4cb-2716-45a7-aaba-5d2aa7a335d9",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/b559d4cb-2716-45a7-aaba-5d2aa7a335d9/homosassa-blue-metal-roof-installation-1320w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/b559d4cb-2716-45a7-aaba-5d2aa7a335d9/homosassa-blue-metal-roof-installation-1320w.avif",
  "original_filename": "homosassa-blue-metal-roof-installation-1320w.avif",
  "size": 75585,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:41Z"
}
